/**
 * @file home-translations.ts
 * @description Central translation repository for the Cultural Troupe Management System.
 * Supports English and Odia.
 */

export const HOME_TRANSLATIONS = {
  "en": {
    "hero": {
      "govt": "Government of Odisha",
      "dept": "Odia Language Literature & Culture Department",
      "logo": "Amakalakara",
      "titleHeader": "Ama Kalakara",
      "title": "Amakalakara - Cultural Troupe Management System",
      "subtitle": "Odia Language Literature & Culture Department, Govt of Odisha",
      "getStarted": "GET STARTED",
      "guideline": "GUIDELINES",
      "verified": "Verified by Odia Language Literature & Culture Department"
    },
    "registration": {
      "agency": {
        "title": "For Requesting Agencies (RA)",
        "desc": "Register your agency to manage cultural events and performers across multiple districts.",
        "button": "Register as Agency"
      },
      "troupeOwner": {
        "title": "For Troupe Leaders (CT)",
        "desc": "Manage members, track performances, apply for schemes - all in one place.",
        "button": "Register as Leader"
      },
      "member": {
        "title": "For Troupe Members (ARTIST)",
        "desc": "Showcase your troupe's talent by registering with us and access exclusive government schemes.",
        "button": "Register as Member"
      }
    },
    "audition": {
      "liveFeed": "Live Feed",
      "title": "Scheduled Auditions",
      "collapse": "Collapse",
      "expand": "Expand"
    },
    "heritage": {
      "title": "The art forms that define Odisha.",
      "subtitle": "Centuries of tradition, alive in every district.",
      "explore": "Explore"
    },
    "artforms": {
      "title": "Odisha's Artistic Legacy",
      "subtitle": "Exploring our vast treasury of art forms.",
      "viewAll": "Clear Filter & View All",
      "heritage": "HERITAGE",
      "viewDetails": "View Details"
    },
    "artformDetail": {
      "translating": "Translating...",
      "aiTranslated": "AI Translated",
      "officialName": "Official Name",
      "category": "Category",
      "significance": "Cultural Significance",
      "description": "is a cornerstone of Odisha's cultural heritage. Rooted in ancient traditions, it continues to thrive as a vibrant expression of the region's artistic identity.",
      "notice": "Registration and audition schedules for this artform are updated periodically by the district cultural offices.",
      "back": "Back to Explore"
    },
    "upcoming": {
      "title": "Upcoming Program",
      "viewAll": "View All"
    },
    "minister": {
      "name": "SHRI MOHAN CHARAN MAJHI",
      "title": "Hon'ble Chief Minister of Odisha",
      "description": "Odisha is a land of rich cultural traditions, vibrant art forms, and timeless heritage. Under the visionary leadership of our Hon'ble Chief Minister, the state is taking bold strides to preserve and promote its glorious cultural identity — nurturing artists, empowering troupes, and bringing Odisha's art to every corner of the nation and beyond."
    },
    "statistics": {
      "title": "Celebrating Odisha's Cultural Excellence at Scale : Previous Financial Year",
      "labels": [
        "Total Registered CT's",
        "Total Requisitioning RA's",
        "Total Active Troupe",
        "No. of Programmes Received",
        "No. of Events Approved",
        "No. of Artforms"
      ]
    },
    "gallery": {
      "eyebrow": "Visual Stories",
      "title": "Gallery",
      "moments": "Moments from across Odisha.",
      "viewAll": "View All",
      "all": "All",
      "close": "Close",
      "categories": {
        "odissi": "Odissi",
        "sambalpuri": "Sambalpuri",
        "bhajan": "Bhajan",
        "drama": "Drama"
      }
    },
    "mobile": {
      "title": "Get the Amakalakara App on Android & iOS",
      "description": "Manage your troupe registrations, track upcoming programs, and stay updated with the latest news from the Odia Language Literature & Culture Department — all from your mobile device."
    },
    "contact": {
      "title": "Have questions or need assistance?",
      "subtitle": "Our support team is here to help you with any cultural troupe or agency inquiries.",
      "button": "CONTACT US",
      "whatsapp": "WhatsApp Chat"
    },
    "categories": {
      "dance": {
        "title": "Dance",
        "desc": "Odissi, Gotipua & more",
        "count": "25+ forms"
      },
      "drama": {
        "title": "Drama",
        "desc": "Pala, Daskathia, Jatra",
        "count": "15+ forms"
      },
      "song": {
        "title": "Song",
        "desc": "Soul-stirring vocals that resonate with the spirit of the land, from bhajans to kirtans.",
        "count": "10+ Genres"
      },
      "music": {
        "title": "Music",
        "desc": "Classical & devotional",
        "count": "10+ forms"
      },
      "folk": {
        "title": "Folk",
        "desc": "Sambalpuri, Chhau, Ghumura",
        "count": "12+ forms"
      }
    },
    "whatsapp": {
      "text": "Say Hello To Instant Whatsapp Chat"
    },
    "socialConnect": {
      "eyebrow": "Stay Connected",
      "title": "Connect With Us",
      "subtitle": "Follow, call, or chat — we're always just a tap away",
      "whatsapp": {
        "name": "WhatsApp",
        "desc": "Chat with us instantly for quick support",
        "cta": "Chat Now",
        "badge": "Live Chat"
      },
      "facebook": {
        "name": "Facebook",
        "desc": "Like our page for updates & events",
        "cta": "Follow Us",
        "badge": "Official Page"
      },
      "instagram": {
        "name": "Instagram",
        "desc": "Follow us for cultural moments & reels",
        "cta": "Follow Us",
        "badge": "Official"
      },
      "phone": {
        "name": "On Call",
        "desc": "Speak directly with our support desk",
        "cta": "Call Now",
        "badge": "Mon-Sat, 10am-5pm"
      },
      "youtube": {
        "name": "YouTube",
        "desc": "Watch our latest cultural programs & showcases",
        "cta": "Subscribe",
        "badge": "Amakalakara Channel"
      },
      "x": {
        "name": "X",
        "desc": "Follow us for regular updates & announcements",
        "cta": "Follow Us",
        "badge": "Official"
      }
    },
    "auditionEmpty": {
      "title": "No Active Auditions",
      "message": "Check back later for upcoming schedules."
    },
    "header": {
      "govt": "Government of Odisha",
      "deptMain": "Odia Language Literature & Culture Department",
      "deptSub": "Government of Odisha",
      "home": "Home",
      "about": {
        "root": "About",
        "objective": {
          "title": "Objective",
          "desc": "Our mission & vision"
        },
        "guidelines": {
          "title": "Guidelines",
          "desc": "Rules & procedures"
        }
      },
      "explore": {
        "root": "Explore",
        "programs": { "title": "Programs", "desc": "Events & schedules" },
        "artforms": { "title": "Artforms", "desc": "Heritage art traditions" },
        "gallery": { "title": "Gallery", "desc": "Photos & videos" }
      },
      "notifications": "Notification",
      "topbar": {
        "govt": "Govt. of Odisha",
        "sitemap": "Sitemap",
        "analytics": "Analytics",
        "screenReader": "Read aloud"
      },
      register: {
        root: "Register",
        agency: {
          title: "RA Registration",
          desc: "Register your agency"
        },
        troupe: {
          title: "Troupe Registration",
          desc: "Register as a troupe"
        },
        troupeOwner: {
          title: "Troupe Leader Registration",
          desc: "Register as a troupe owner"
        },
        troupeMember: {
          title: "Member Registration",
          desc: "Register as a troupe member"
        },
        checkStatus: {
          title: "Check Status",
          desc: "Check your registration status"
        },
        updateAudition: {
          title: "Update Audition Details",
          desc: "Update your audition details"
        }
      },
      "help": {
        "root": "Help & Support",
        "contact": {
          "title": "Contact Us",
          "desc": "Get in touch"
        },
        "tutorial": "Tutorial Videos",
        "tutorialDesc": "Watch step-by-step registration guides"
      },
      "login": "Login",
      "helpline": "Helpline",
      "helplineValue": "6372901907",
      "contactBtn": "Contact Us",
      "cm": {
        "name": "Shri Mohan Charan Majhi",
        "role": "Chief Minister"
      },
      "state_minister": {
        "name": "Shri Suryabanshi Suraj",
        "role": "Minister of State (Independent)"
      }
    },
    "footer": {
      "dept": "Odia Language Literature & Culture Department",
      "govt": "Government of Odisha",
      "deptDesc": "An initiative of the Odia Language, Literature & Culture Department to preserve, promote and celebrate the cultural heritage of Odisha.",
      "stayUpdated": "Stay Updated",
      "stayUpdatedDesc": "Subscribe for cultural events, schemes & departmental notifications.",
      "emailPlaceholder": "Your email address",
      "subscribeBtn": "Subscribe",
      "subscribing": "Subscribing…",
      "invalidEmail": "Please enter a valid email address.",
      "quickLinks": "Quick Links",
      "home": "Home",
      "about": "About",
      "explore": "Explore",
      "help": "Help & Support",
      "contactTitle": "Contact",
      "phoneLabel": "Phone",
      "address": "Sanskruti Bhavan, Kalpana Square, Bhubaneswar - 751014, Odisha",
      "phone": "6372901907",
      "tollFree": "",
      "email": "Email",
      "emailId": "directorateofculture@gmail.com",
      "newsletter": "Newsletter",
      "subscribe": "Subscribe Now",
      "scanToChat": "Scan to chat",
      "scanAccess": "Scan to access",
      "amaKalakarApp": "Ama Kalakar Mobile",
      "downloadleaflet": "Download AmaKalakara Leaflet",
      "downloadAffidavit": "Download Affidavit",
      "minor_authorizationLetterHint": "For age below 14, if the affidavit is filled please upload else download the template, fill the details and upload it",
      "sitemap": "Sitemap",
      "analytics": "Analytics",
      "terms": "Terms of Use",
      "privacy": "Privacy Policy",
      "contact": "Contact Us",
      "copy": "Copyright © 2026 Amakalakara. All Rights Reserved."
    },
    "privacy": {
      "title": "Privacy Policy",
      "lastUpdated": "Last Updated: April 2026",
      "intro": "This Privacy Policy describes how the Odia Language Literature & Culture Department, Government of Odisha, collects, uses, and protects the personal information of artists, troupe owners, and agencies registered on the Amakalakara Portal.",
      "sections": [
        {
          "title": "Information We Collect",
          "content": "We collect information necessary for registration and cultural management, including: Name, Contact Details, Address, Bank Account details (for DBT), Troupe category, and Artform expertise."
        },
        {
          "title": "How We Use Your Information",
          "content": "Your data is used to verify registrations, schedule auditions, disburse government incentives via Direct Benefit Transfer (DBT), and promote cultural events."
        },
        {
          "title": "Data Security",
          "content": "We implement robust security measures to protect your data. Aadhaar and Bank details are stored in an encrypted format and accessible only to authorized personnel."
        },
        {
          "title": "Information Sharing",
          "content": "We share necessary information with District Cultural Officers (DCOs) and participating Banks for payment processing. We do not sell your data to third parties."
        }
      ]
    },
    "termsOfService": {
      "title": "Terms of Use",
      "lastUpdated": "Last Updated: April 2026",
      "intro": "Welcome to the Amakalakara Portal, an initiative of the Odia Language Literature & Culture Department, Government of Odisha. By accessing or using this website/application, you agree to comply with and be bound by the following Terms of Use.",
      "sections": [
        {
          "title": "Acceptance of Terms",
          "content": "By accessing this portal, you confirm your acceptance of these Terms of Use and agree to abide by all applicable local, state, and national laws and regulations. If you do not agree, please refrain from using the portal."
        },
        {
          "title": "User Accounts & Security",
          "content": "Registered artists, troupe leaders, and requesting agencies are responsible for maintaining the confidentiality of their login credentials. All information provided during registration (including Aadhaar and Bank accounts) must be authentic and correct."
        },
        {
          "title": "Code of Conduct & Guidelines",
          "content": "Users must participate in cultural events and troupe management in an ethical manner. Performance reports, financial claims, and member profiles submitted on this portal must be verified and accurate. Misrepresentation may lead to de-registration."
        },
        {
          "title": "Portal Availability & Modifications",
          "content": "The Department reserves the right to modify, suspend, or discontinue any aspect of the portal, including government schemes, incentives, or features, at any time without prior notice."
        },
        {
          "title": "Limitation of Liability",
          "content": "The Department shall not be liable for any direct, indirect, or incidental damages arising out of the use of, or inability to use, the portal. All disbursements of incentives are subject to verification and budget availability."
        }
      ]
    },
    "timeline": {
      "title": "Important Schedule & Key Dates",
      "subtitle": "Important timelines for the registration, scrutiny, audition, and booking process of Ama Kalakara",

      "steps": [
        {
          "title": "Online Registration of Requesting Agency (RA)",
          "date": "16.08.2026 onwards"
        },
        {
          "title": "Online Registration of Cultural Troupes (CT)",
          "date": "16.08.2026 to 06.09.2026 (Extended)"
        },
        {
          "title": "Preliminary Scrutiny at DCO Level",
          "date": "16.08.2026 to 10.09.2026 (Extended)"
        },
        {
          "title": "Audition Period",
          "date": "Will be notified by DCO in the portal"
        },
        {
          "title": "Publication of total CT list",
          "date": "Will be notified by DCO in the portal"
        },
        {
          "title": "Orientation of CT & RA",
          "date": "Will be notified by DCO in the portal"
        },
        {
          "title": "Onset online CT Booking",
          "date": "Will be notified by DCO in the portal"
        }
      ]
    }
  },
  "or": {
    "hero": {
      "govt": "ଓଡ଼ିଶା ସରକାର",
      "dept": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ",
      "logo": "ଆମ କଳାକାର",
      "titleHeader": "ଆମ କଳାକାର",
      "title": "ସାଂସ୍କୃତିକ ଦଳ ପରିଚାଳନା ପ୍ରଣାଳୀ",
      "subtitle": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ, ଓଡ଼ିଶା ସରକାର",
      "getStarted": "ଆରମ୍ଭ କରନ୍ତୁ",
      "guideline": "ନିର୍ଦ୍ଦେଶାବଳୀ",
      "verified": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ ଦ୍ୱାରା ଯାଞ୍ଚ ହୋଇଛି"
    },
    "registration": {
      "agency": {
        "title": "ଅନୁରୋଧକାରୀ ସଂସ୍ଥା ପଞ୍ଜୀକରଣ କରନ୍ତୁ",
        "desc": "ଏକାଧିକ ଜିଲ୍ଲାରେ ସାଂସ୍କୃତିକ ଦଳ ଏବଂ କଳାକାରମାନଙ୍କୁ ପରିଚାଳନା କରିବା ପାଇଁ ଆପଣଙ୍କର ସଂସ୍ଥାକୁ ପଞ୍ଜୀକରଣ କରନ୍ତୁ",
        "button": "ଏବେ ପଞ୍ଜୀକରଣ କରନ୍ତୁ"
      },
      "troupeOwner": {
        "title": "ସାଂସ୍କୃତିକ ଦଳର ମୁଖ୍ୟ ଭାବରେ ପଞ୍ଜୀକରଣ କରନ୍ତୁ",
        "desc": "ସଦସ୍ୟ ପରିଚାଳନା, ପ୍ରଦର୍ଶନୀ ତଥ୍ୟ ଓ ଯୋଜନା ଆବେଦନ – ସବୁ ଗୋଟିଏ ସ୍ଥାନରେ ।",
        "button": "ଏବେ ପଞ୍ଜୀକରଣ କରନ୍ତୁ"
      },
      "member": {
        "title": "ଦଳ ସଦସ୍ୟଙ୍କ ପାଇଁ",
        "desc": "ଆଜି ହିଁ ଆମ ସହିତ ପଞ୍ଜୀକୃତ ହୋଇ ଆପଣ ନିଜ କଳା ପ୍ରଦର୍ଶନ କରନ୍ତୁ ଏବଂ ସରକାରୀ ସୁବିଧା ପାଆନ୍ତୁ ",
        "button": "ସଦସ୍ୟ ଭାବରେ ପଞ୍ଜୀକରଣ କରନ୍ତୁ"
      }
    },
    "audition": {
      "liveFeed": "ଲାଇଭ୍ ଫିଡ୍",
      "title": "ନିର୍ଦ୍ଧାରିତ ଅଡ଼ିସନ",
      "collapse": "ସଂକୋଚନ କରନ୍ତୁ",
      "expand": "ବିସ୍ତାର କରନ୍ତୁ"
    },
    "heritage": {
      "title": "ଆମର ଐତିହ୍ୟକୁ ଅନୁସନ୍ଧାନ କରନ୍ତୁ",
      "subtitle": "ଆମର ସାଂସ୍କୃତିକ ପରିଚୟକୁ ପରିଭାଷିତ କରୁଥିବା ବିବିଧ କଳା ଆବିଷ୍କାର କରନ୍ତୁ ।",
      "explore": "ଅନୁସନ୍ଧାନ କରନ୍ତୁ"
    },
    "artforms": {
      "title": "ଓଡ଼ିଶାର କଳାତ୍ମକ ଐତିହ୍ୟ",
      "subtitle": "ଆମର ବିଶାଳ କଳା ଭଣ୍ଡାରର ଅନୁସନ୍ଧାନ କରନ୍ତୁ ।",
      "viewAll": "ଫିଲ୍ଟର ହଟାନ୍ତୁ ଏବଂ ସମସ୍ତ ଦେଖନ୍ତୁ",
      "heritage": "ଐତିହ୍ୟ",
      "viewDetails": "ଦେଖନ୍ତୁ"
    },
    "artformDetail": {
      "translate": "ଓଡ଼ିଆରେ ଅନୁବାଦ କରନ୍ତୁ",
      "translating": "ଅନୁବାଦ ହେଉଛି...",
      "aiTranslated": "AI ଅନୁବାଦିତ",
      "officialName": "ସରକାରୀ ନାମ",
      "category": "ବର୍ଗ",
      "significance": "ସାଂସ୍କୃତିକ ଗୁରୁତ୍ୱ",
      "description": "ଓଡ଼ିଶାର ସାଂସ୍କୃତିକ ଐତିହ୍ୟର ଏକ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ଅଂଶ। ପ୍ରାଚୀନ ପରମ୍ପରାରେ ଚେର ରଖିଥିବା ଏହି କଳା ଆଞ୍ଚଳିକ କଳାତ୍ମକ ପରିଚୟର ଏକ ଜୀବନ୍ତ ଅଭିପ୍ରାୟ ଭାବରେ ସମୃଦ୍ଧ ହେବାରେ ଲାଗିଛି।",
      "notice": "ଏହି କଳା ପାଇଁ ପଞ୍ଜୀକରଣ ଏବଂ ଅଡ଼ିସନ୍ ସମୟ ସାରଣୀ ଜିଲ୍ଲା ସାଂସ୍କୃତିକ କାର୍ଯ୍ୟାଳୟ ଦ୍ୱାରା ସମୟାନୁସାରେ ଅପଡେଟ୍ କରାଯାଇଥାଏ।",
      "back": "ଫେରି ଯାଆନ୍ତୁ"
    },
    "upcoming": {
      "title": "ଆଗାମୀ କାର୍ଯ୍ୟକ୍ରମ",
      "viewAll": "ସମସ୍ତ ଦେଖନ୍ତୁ"
    },
    "minister": {
      "name": "ଶ୍ରୀ ମୋହନ ଚରଣ ମାଝୀ",
      "title": "ମାନ୍ୟବର ମୁଖ୍ୟମନ୍ତ୍ରୀ, ଓଡ଼ିଶା",
      "description": "ଓଡ଼ିଶା ସମୃଦ୍ଧ ସାଂସ୍କୃତିକ ପରମ୍ପରା, ଜୀବନ୍ତ କଳା ଏବଂ କାଳଜୟୀ ଐତିହ୍ୟର ଭୂମି। ଆମର ମାନ୍ୟବର ମୁଖ୍ୟମନ୍ତ୍ରୀଙ୍କ ଦୂରଦୃଷ୍ଟିସମ୍ପନ୍ନ ନେତୃତ୍ୱରେ, ରାଜ୍ୟ ଏହାର ଗୌରବମୟ ସାଂସ୍କୃତିକ ପରିଚୟକୁ ବଜାୟ ରଖିବା ଏବଂ ପ୍ରଚାର କରିବା ପାଇଁ ବଳିଷ୍ଠ ପଦକ୍ଷେପ ନେଉଛି — କଳାକାରମାନଙ୍କୁ ଉତ୍ସାହିତ କରିବା, ଦଳଗୁଡ଼ିକୁ ସଶକ୍ତ କରିବା ଏବଂ ଓଡ଼ିଶାର କଳାକୁ ଦେଶ ଓ ବିଦେଶର ପ୍ରତିଟି କୋଣରେ ପହଞ୍ଚାଇବା ପାଇଁ।"
    },
    "statistics": {
      "title": "ଓଡ଼ିଶାର ସାଂସ୍କୃତିକ ଉତ୍କର୍ଷକୁ ବ୍ୟାପକ ସ୍ତରରେ ପାଳନ କରାଯାଉଛି : ବିଗତ ଆର୍ଥିକ ବର୍ଷରେ",
      "labels": [
        "ମୋଟ ପଞ୍ଜୀକୃତ ସାଂସ୍କୃତିକ ଦଳ",
        "ମୋଟ ପଞ୍ଜୀକୃତ ଅନୁରୋଧକାରୀ ସଂସ୍ଥା",
        "ମୋଟ ସକ୍ରିୟ ଦଳ",
        "ପ୍ରାପ୍ତ କାର୍ଯ୍ୟକ୍ରମ ସଂଖ୍ୟା",
        "ଅନୁମୋଦିତ କାର୍ଯ୍ୟକ୍ରମ ସଂଖ୍ୟା",
        "ମୋଟ କଳାବର୍ଗ ସଂଖ୍ୟା"
      ]
    },
    "gallery": {
      "eyebrow": "ଦୃଶ୍ୟ କାହାଣୀ",
      "title": "ଗ୍ୟାଲେରୀ",
      "moments": "ଓଡ଼ିଆ ସଂସ୍କୃତିର ଅଭୁଲା ମୁହୂର୍ତ୍ତ",
      "viewAll": "ସମସ୍ତ ଦେଖନ୍ତୁ",
      "all": "ସମସ୍ତ",
      "close": "ବନ୍ଦ କରନ୍ତୁ",
      "categories": {
        "odissi": "ଓଡ଼ିଶୀ",
        "sambalpuri": "ସମ୍ବଲପୁରୀ",
        "bhajan": "ଭଜନ",
        "drama": "ନାଟକ"
      }
    },
    "mobile": {
      "title": "Android ଏବଂ iOS ରେ ଆମ କଳାକାର ଆପ୍ ପାଆନ୍ତୁ",
      "description": "ଆପଣଙ୍କର ଦଳ ପଞ୍ଜୀକରଣ ପରିଚାଳନା କରନ୍ତୁ, ଆଗାମୀ କାର୍ଯ୍ୟକ୍ରମଗୁଡ଼ିକୁ ଟ୍ରାକ୍ କରନ୍ତୁ ଏବଂ ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗର ସଦ୍ୟତମ ଖବର ସହିତ ଅପଡେଟ୍ ରୁହନ୍ତୁ — ସେହି ସବୁ ଆପଣଙ୍କ ମୋବାଇଲ୍ ଡିଭାଇସ୍‌ରୁ"
    },
    "contact": {
      "title": "କୌଣସି ପ୍ରଶ୍ନ ଅଛି କିମ୍ବା ସହାୟତା ଦରକାର କି ?",
      "subtitle": "ଆମର ସମର୍ଥନ ଦଳ କୌଣସି ସାଂସ୍କୃତିକ ଦଳ କିମ୍ବା ଏଜେନ୍ସି ଅନୁସନ୍ଧାନ ପାଇଁ ଆପଣଙ୍କୁ ସାହାଯ୍ୟ କରିବାକୁ ଏଠାରେ ଅଛନ୍ତି",
      "button": "ଯୋଗାଯୋଗ କରନ୍ତୁ",
      "whatsapp": "ହ୍ୱାଟସ୍‌ଆପ୍ ଚାଟ୍"
    },
    "categories": {
      "dance": {
        "title": "ନୃତ୍ୟ",
        "desc": "ପାରମ୍ପରିକ ନୃତ୍ୟର ତାଳ, ଲୟ ଓ ସୌନ୍ଦର୍ଯ୍ୟକୁ ଅନୁଭବ କରନ୍ତୁ, ଯାହା କାହାଣୀଗୁଡ଼ିକୁ ଜୀବନ୍ତ କରେ",
        "count": "୨୫+ ରୁ ଅଧିକ"
      },
      "drama": {
        "title": "ନାଟକ / ଅପେରା",
        "desc": "ଆମ ସଂସ୍କୃତିରେ ଗଭୀର ଭାବରେ ମୂଳ, ଲୋକ ନାଟ୍ୟ ଏବଂ ନାଟକ ପ୍ରାଚୀନ କାହାଣୀର ଏକ ଝଲକ ପ୍ରଦାନ କରେ",
        "count": "୧୫+ ରୁ ଅଧିକ"
      },
      "song": {
        "title": "ସଙ୍ଗୀତ",
        "desc": "ଭଜନ ଠାରୁ କୀର୍ତ୍ତନ ପର୍ଯ୍ୟନ୍ତ, ଭୂମିର ଆତ୍ମା ସହିତ ପ୍ରତିଧ୍ୱନିତ ହେଉଥିବା ଆତ୍ମା-ଆକର୍ଷକ କଣ୍ଠସ୍ୱର",
        "count": "୧୦+ ରୁ ଅଧିକ"
      },
      "music": {
        "title": "ବାଦ୍ୟ",
        "desc": "ଶାସ୍ତ୍ରୀୟ ବାଦ୍ୟଯନ୍ତ୍ରର କାଳଜୟୀ ଶବ୍ଦ ଯାହା ପିଢ଼ି ପିଢ଼ିକୁ ମନ୍ତ୍ରମୁଗ୍ଧ କରିଆସିଛି",
        "count": "୧୨+ ରୁ ଅଧିକ"
      },
      "folk": {
        "title": "ଲୋକକଳା",
        "desc": "ସମ୍ବଲପୁରୀ, ଛଉ, ଘୁମୁରା",
        "count": "୧୨+ ରୁ ଅଧିକ"
      }
    },
    "whatsapp": {
      "text": "ତୁରନ୍ତ ହ୍ୱାଟସ୍‌ଆପ୍ ଚାଟ୍ ପାଇଁ ହ୍ୟାଲୋ କୁହନ୍ତୁ"
    },
    "socialConnect": {
      "eyebrow": "ଯୋଡ଼ି ହୋଇ ରୁହନ୍ତୁ",
      "title": "ଆମ ସହ ଯୋଡ଼ି ହୁଅନ୍ତୁ",
      "subtitle": "ଅନୁସରଣ କରନ୍ତୁ, କଲ୍ କରନ୍ତୁ କିମ୍ବା ଚାଟ୍ କରନ୍ତୁ — ଆମେ ସର୍ବଦା ଆପଣଙ୍କ ପାଖରେ",
      "whatsapp": {
        "name": "ହ୍ୱାଟସ୍‌ଆପ୍",
        "desc": "ତୁରନ୍ତ ସାହାଯ୍ୟ ପାଇଁ ଆମ ସହିତ ଚାଟ୍ କରନ୍ତୁ",
        "cta": "ଏବେ ଚାଟ୍ କରନ୍ତୁ",
        "badge": "ଲାଇଭ୍ ଚାଟ୍"
      },
      "facebook": {
        "name": "ଫେସବୁକ୍",
        "desc": "ସୂଚନା ଏବଂ ଇଭେଣ୍ଟ ପାଇଁ ଆମ ପେଜ୍‌କୁ ଲାଇକ୍ କରନ୍ତୁ",
        "cta": "ଅନୁସରଣ କରନ୍ତୁ",
        "badge": "ସରକାରୀ ପେଜ୍"
      },
      "instagram": {
        "name": "ଇନଷ୍ଟାଗ୍ରାମ୍",
        "desc": "ସାଂସ୍କୃତିକ ମୁହୂର୍ତ୍ତ ଏବଂ ରିଲ୍ସ ପାଇଁ ଆମକୁ ଅନୁସରଣ କରନ୍ତୁ",
        "cta": "ଅନୁସରଣ କରନ୍ତୁ",
        "badge": "ସରକାରୀ"
      },
      "phone": {
        "name": "କଲ୍ କରନ୍ତୁ",
        "desc": "ଆମ ସହାୟତା ଡେସ୍କ ସହିତ ସିଧାସଳଖ କଥା ହୁଅନ୍ତୁ",
        "cta": "ଏବେ କଲ୍ କରନ୍ତୁ",
        "badge": "ସୋମ-ଶନି, ସକାଳ ୧୦ ରୁ ୫"
      },
      "youtube": {
        "name": "ୟୁଟ୍ୟୁବ୍",
        "desc": "ଆମର ନୂତନ ସାଂସ୍କୃତିକ କାର୍ଯ୍ୟକ୍ରମ ଏବଂ ପ୍ରଦର୍ଶନ ଦେଖନ୍ତୁ",
        "cta": "ସବସ୍କ୍ରାଇବ୍ କରନ୍ତୁ",
        "badge": "ଆମ କଳାକାର"
      },
      "x": {
        "name": "X",
        "desc": "ସାଂସ୍କୃତିକ କାର୍ଯ୍ୟକ୍ରମରେ ନିୟମିତ ଅପଡେଟ୍‌ସ ପାଇଁ ଆମକୁ ଅନୁସରଣ କରନ୍ତୁ",
        "cta": "ଅନୁସରଣ କରନ୍ତୁ",
        "badge": "ସରକାରୀ"
      }
    },
    "auditionEmpty": {
      "title": "କୌଣସି ସକ୍ରିୟ ଅଡ଼ିସନ୍ ନାହିଁ",
      "message": "ଆଗାମୀ କାର୍ଯ୍ୟକ୍ରମ ପାଇଁ ପରେ ଦେଖନ୍ତୁ"
    },
    "header": {
      "govt": "ଓଡ଼ିଶା ସରକାର",
      "deptMain": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ",
      "deptSub": "ଓଡ଼ିଶା ସରକାର",
      "home": "ମୁଖ୍ୟ ପୃଷ୍ଠା",
      "about": {
        "root": "ଆମ ବିଷୟରେ",
        "objective": {
          "title": "ଉଦ୍ଦେଶ୍ୟ",
          "desc": "ଆମର ଲକ୍ଷ୍ୟ ଏବଂ ସଂକଳ୍ପ"
        },
        "guidelines": {
          "title": "ମାର୍ଗଦର୍ଶିକା",
          "desc": "ନିୟମ ଏବଂ ପ୍ରକ୍ରିୟା"
        }
      },
      "explore": {
        "root": "ଅନୁସନ୍ଧାନ",
        "programs": { "title": "କାର୍ଯ୍ୟକ୍ରମ", "desc": "ଘଟଣା ଏବଂ କାର୍ଯ୍ୟସୂଚୀ" },
        "artforms": { "title": "କଳା ରୂପ", "desc": "ଐତିହ୍ୟ କଳା ପରମ୍ପରା" },
        "gallery": { "title": "ଗ୍ୟାଲେରୀ", "desc": "ଫଟୋ ଏବଂ ଭିଡିଓ" }
      },
      "notifications": "ସୂଚନା",
      "topbar": {
        "govt": "ଓଡ଼ିଶା ସରକାର",
        "sitemap": "ସାଇଟ୍ ମ୍ୟାପ୍",
        "analytics": "ଆନାଲିଟିକ୍ସ",
        "screenReader": "ସ୍କ୍ରିନ୍ ରିଡର୍ ବ୍ୟବସ୍ଥା"
      },
      register: {
        root: "ପଞ୍ଜୀକରଣ",
        agency: {
          title: "ଅନୁରୋଧକାରୀ ସଂସ୍ଥା ପଞ୍ଜୀକରଣ",
          desc: "ଆପଣଙ୍କ ସଂସ୍ଥାକୁ ପଞ୍ଜୀକୃତ କରନ୍ତୁ"
        },
        troupe: {
          title: "ସାଂସ୍କୃତିକ ଦଳ ପଞ୍ଜୀକରଣ",
          desc: "ଦଳ ଭାବରେ ପଞ୍ଜୀକୃତ ହୁଅନ୍ତୁ"
        },
        troupeOwner: {
          title: "ସାଂସ୍କୃତିକ ଦଳ ପଞ୍ଜୀକରଣ",
          desc: "ଦଳମୁଖ୍ୟ ଭାବରେ ପଞ୍ଜୀକୃତ ହୁଅନ୍ତୁ"
        },
        troupeMember: {
          title: "କଳାକାର ପଞ୍ଜୀକରଣ",
          desc: "କଳାକାର ଭାବରେ ପଞ୍ଜୀକୃତ ହୁଅନ୍ତୁ"
        },
        checkStatus: {
          title: "ସ୍ଥିତି ଯାଞ୍ଚ",
          desc: "ଆପଣଙ୍କ ପଞ୍ଜୀକରଣ ସ୍ଥିତି ଦେଖନ୍ତୁ"
        },
        updateAudition: {
          title: "ଅଡ଼ିସନ୍ ତଥ୍ୟ ଅପଡେଟ କରନ୍ତୁ",
          desc: "ଆପଣଙ୍କ ଅଡ଼ିସନ୍ ତଥ୍ୟ ଅପଡେଟ କରନ୍ତୁ"
        }
      },
      "help": {
        "root": "ସହାୟତା",
        "support": {
          "title": "ପଞ୍ଜୀକରଣ ସ୍ଥିତି",
          "desc": "ଆପଣଙ୍କ ପଞ୍ଜୀକରଣ ସ୍ଥିତି ଯାଞ୍ଚ କରନ୍ତୁ"
        },
        "contact": {
          "title": "ଯୋଗାଯୋଗ",
          "desc": "ଆମ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ"
        },
        "tutorial": "ସହାୟତା ଭିଡିଓ",
        "tutorialDesc": "ପଞ୍ଜୀକରଣ ପ୍ରକ୍ରିୟା ଭିଡିଓ ଦେଖନ୍ତୁ"
      },
      "login": "ଲଗ୍-ଇନ୍",
      "helpline": "ହେଲ୍ପଲାଇନ୍",
      "helplineValue": "୬୩୭୨୯୦୧୯୦୭",
      "contactBtn": "ଯୋଗାଯୋଗ କରନ୍ତୁ",
      "cm": {
        "name": "ଶ୍ରୀ ମୋହନ ଚରଣ ମାଝୀ",
        "role": "ମୁଖ୍ୟମନ୍ତ୍ରୀ"
      },
      "state_minister": {
        "name": "ଶ୍ରୀ ସୂର୍ଯ୍ୟବଂଶୀ ସୂରଜ",
        "role": "ରାଷ୍ଟ୍ର ମନ୍ତ୍ରୀ (ସ୍ୱାଧୀନ)"
      }
    },
    "footer": {
      "dept": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ",
      "govt": "ଓଡ଼ିଶା ସରକାର",
      "deptDesc": "ଓଡ଼ିଶାର ସମୃଦ୍ଧ ସାଂସ୍କୃତିକ ଐତିହ୍ୟର ସଂରକ୍ଷଣ, ପ୍ରସାର ଏବଂ ଉତ୍ସବ ପାଳନ ପାଇଁ ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗର ଏକ ପ୍ରୟାସ |",
      "stayUpdated": "ନୂତନ ସୂଚନା ପାଆନ୍ତୁ",
      "stayUpdatedDesc": "ସାଂସ୍କୃତିକ କାର୍ଯ୍ୟକ୍ରମ, ଯୋଜନା ଏବଂ ବିଭାଗୀୟ ବିଜ୍ଞପ୍ତି ପାଇଁ ସଦସ୍ୟତା ଗ୍ରହଣ କରନ୍ତୁ",
      "emailPlaceholder": "ଆପଣଙ୍କର ଇମେଲ୍ ଠିକଣା",
      "subscribeBtn": "ସଦସ୍ୟତା ଗ୍ରହଣ କରନ୍ତୁ",
      "subscribing": "ସଦସ୍ୟତା ନିଆଯାଉଛି...",
      "invalidEmail": "ଦୟାକରି ଏକ ବୈଧ ଇମେଲ୍ ଠିକଣା ପ୍ରଦାନ କରନ୍ତୁ",
      "quickLinks": "ସହଜ ପ୍ରବେଶ ଲିଙ୍କ",
      "home": "ମୁଖ୍ୟ ପୃଷ୍ଠା",
      "about": "ବିଷୟରେ",
      "explore": "ଅନ୍ୱେଷଣ କରନ୍ତୁ",
      "help": "ସହାୟତା ଏବଂ ସମର୍ଥନ",
      "contactTitle": "ଯୋଗାଯୋଗ ଠିକଣା",
      "address": "ସଂସ୍କୃତି ଭବନ, କଳ୍ପନା ଛକ, ଭୁବନେଶ୍ୱର - ୭୫୧୦୧୪, ଓଡ଼ିଶା",
      "phone": "୬୩୭୨୯୦୧୯୦୭",
      "tollFree": "",
      "email": "ଇମେଲ",
      "emailId": "ଇନଫୋ@ଆମକଳାକାର.ଓଡିଶା.ଗଭ.ଇନ",
      "newsletter": "ଖବର ଚିଠି",
      "subscribe": "ବର୍ତ୍ତମାନ ସଦସ୍ୟ ହୁଅନ୍ତୁ",
      "scan": "ଚାଟ୍ ପାଇଁ ସ୍କାନ୍ କରନ୍ତୁ",
      "scanAccess": "ପ୍ରବେଶ ପାଇଁ ସ୍କାନ କରନ୍ତୁ",
      "amaKalakarApp": "ଆମ କଳାକାର ମୋବାଇଲ",
      "downloadleaflet": "ଆମ କାଲାକାର ଲିଫଲେଟ୍ ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
      "downloadAffidavit": "ସମ୍ମତିପତ୍ର/ଘୋଷଣାପତ୍ର ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
      "minor_authorizationLetterHint": "କଳାକାରଙ୍କ ବୟସ ୧୪ ବର୍ଷରୁ କମ୍ ହେଲେ, ଅଭିଭାବକଙ୍କ ସମ୍ମତିପତ୍ର/ଘୋଷଣାପତ୍ର ଡାଉନଲୋଡ୍ କରି, ଆବଶ୍ୟକ ସୂଚନା ପୂରଣ କରି ଅପଲୋଡ୍ କରନ୍ତୁ ।",
      "sitemap": "ସାଇଟ୍ ମ୍ୟାପ୍",
      "analytics": "ଆନାଲିଟିକ୍ସ",
      "terms": "ବ୍ୟବହାରର ସର୍ତ୍ତାବଳୀ",
      "privacy": "ଗୋପନୀୟତା ନୀତି",
      "contact": "ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ",
      "copy": "ସର୍ବାଧିକାର ସଂରକ୍ଷିତ © ୨୦୨୬ ଆମ କଳାକାର |",
      "phoneLabel": "ଫୋନ",
      "contactSub": "ଆମେ ସାହାଯ୍ୟ କରିବା ପାଇଁ ଅଛୁ",
      "addressLabel": "ଏଠାରେ ଯୋଗାଯୋଗ କରନ୍ତୁ"
    },
    "privacy": {
      "title": "ଗୋପନୀୟତା ନୀତି",
      "lastUpdated": "ଶେଷ ଅପଡେଟ୍: ଏପ୍ରିଲ୍ ୨୦୨୬",
      "intro": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ, ଓଡ଼ିଶା ସରକାର ଦ୍ୱାରା ପରିଚାଳିତ ସାଂସ୍କୃତିକ ଦଳ ପରିଚାଳନା ବ୍ୟବସ୍ଥା (ଆମ କଳାକାର) ରେ ପଞ୍ଜୀକୃତ କଳାକାର, ଦଳମୁଖ୍ୟ ଏବଂ ସଂସ୍ଥାମାନଙ୍କର ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ କିପରି ସଂଗ୍ରହ, ବ୍ୟବହାର ଏବଂ ସୁରକ୍ଷିତ ରଖାଯାଏ, ସେ ବିଷୟରେ ଏହି ଗୋପନୀୟତା ନୀତି ବ୍ୟାଖ୍ୟା କରେ ।",
      "sections": [
        {
          "title": "ଆମେ ସଂଗ୍ରହ କରୁଥିବା ସୂଚନା",
          "content": "ପଞ୍ଜୀକରଣ ଏବଂ ସାଂସ୍କୃତିକ ପରିଚାଳନା ପାଇଁ ଆବଶ୍ୟକୀୟ ତଥ୍ୟ ଆମେ ସଂଗ୍ରହ କରୁ, ଯେପରିକି: ନାମ, ଯୋଗାଯୋଗ ସୂଚନା, ଠିକଣା, ବ୍ୟାଙ୍କ ଆକାଉଣ୍ଟ ବିବରଣୀ (DBT ପାଇଁ), ଦଳର ବର୍ଗ ଏବଂ କଳା ପ୍ରକାରର ଅଭିଜ୍ଞତା ।"
        },
        {
          "title": "ଆପଣଙ୍କ ସୂଚନାର ବ୍ୟବହାର",
          "content": "ଆପଣଙ୍କର ତଥ୍ୟ ପଞ୍ଜୀକରଣ ଯାଞ୍ଚ କରିବା, ଅଡ଼ିସନ୍ ସମୟ ସ୍ଥିର କରିବା, ସରକାରୀ ପ୍ରୋତ୍ସାହନ ରାଶି DBT ମାଧ୍ୟମରେ ପ୍ରଦାନ କରିବା ଏବଂ ସାଂସ୍କୃତିକ କାର୍ଯ୍ୟକ୍ରମର ପ୍ରଚାର ପାଇଁ ବ୍ୟବହାର କରାଯାଏ ।"
        },
        {
          "title": "ତଥ୍ୟ ସୁରକ୍ଷା",
          "content": "ଆମେ ଆପଣଙ୍କର ତଥ୍ୟକୁ ସୁରକ୍ଷିତ ରଖିବା ପାଇଁ ଶକ୍ତିଶାଳୀ ନିରାପତ୍ତା ବ୍ୟବସ୍ଥା ଗ୍ରହଣ କରୁ। ଆଧାର ଏବଂ ବ୍ୟାଙ୍କ ବିବରଣୀ ଏନକ୍ରିପ୍ଟେଡ୍ ଫର୍ମାଟ୍‌ରେ ଗଚ୍ଛିତ ରଖାଯାଏ ଏବଂ କେବଳ ଅଧିକୃତ ବ୍ୟକ୍ତିମାନେ ଏହାକୁ ଦେଖିପାରିବେ ।"
        },
        {
          "title": "ତଥ୍ୟ ବଣ୍ଟନ",
          "content": "ଆମେ ପେମେଣ୍ଟ ପ୍ରକ୍ରିୟା ପାଇଁ ଜିଲ୍ଲା ସାଂସ୍କୃତିକ ଅଧିକାରୀ (DCO) ଏବଂ ସଂପୃକ୍ତ ବ୍ୟାଙ୍କଗୁଡ଼ିକ ସହିତ ଆବଶ୍ୟକୀୟ ସୂଚନା ସେୟାର କରୁ। ଆମେ ଆପଣଙ୍କର ତଥ୍ୟକୁ କୌଣସି ତୃତୀୟ ପକ୍ଷକୁ ବିକ୍ରି କରୁନାହୁଁ ।"
        }
      ]
    },
    "termsOfService": {
      "title": "ବ୍ୟବହାରର ସର୍ତ୍ତାବଳୀ",
      "lastUpdated": "ଶେଷ ଅପଡେଟ୍: ଏପ୍ରିଲ୍ ୨୦୨୬",
      "intro": "ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଓ ସଂସ୍କୃତି ବିଭାଗ, ଓଡ଼ିଶା ସରକାରଙ୍କ ଏକ ପ୍ରୟାସ 'ଆମ କଳାକାର' ପୋର୍ଟାଲ୍‌କୁ ସ୍ୱାଗତ। ଏହି ୱେବସାଇଟ୍/ଆପ୍ ବ୍ୟବହାର କରିବା ଦ୍ୱାରା, ଆପଣ ନିମ୍ନଲିଖିତ ବ୍ୟବହାରର ସର୍ତ୍ତାବଳୀକୁ ମାନିବାକୁ ଏବଂ ଏହା ଦ୍ୱାରା ବାଧ୍ୟ ରହିବାକୁ ସହମତ ହେଉଛନ୍ତି ।",
      "sections": [
        {
          "title": "ସର୍ତ୍ତାବଳୀ ଗ୍ରହଣ",
          "content": "ଏହି ପୋର୍ଟାଲ୍ ବ୍ୟବହାର କରି, ଆପଣ ଏହି ବ୍ୟବହାରର ସର୍ତ୍ତାବଳୀକୁ ଗ୍ରହଣ କରୁଥିବା ନିଶ୍ଚିତ କରୁଛନ୍ତି ଏବଂ ସମସ୍ତ ପ୍ରଯୁଜ୍ୟ ସ୍ଥାନୀୟ, ରାଜ୍ୟ ଏବଂ ଜାତୀୟ ନିୟମ ଓ ନିୟମାବଳୀକୁ ପାଳନ କରିବାକୁ ସହମତ ହେଉଛନ୍ତି। ଯଦି ଆପଣ ସହମତ ନୁହଁନ୍ତି, ତେବେ ଦୟାକରି ଏହି ପୋର୍ଟାଲ୍ ବ୍ୟବହାର କରନ୍ତୁ ନାହିଁ ।"
        },
        {
          "title": "ଉପଭୋକ୍ତା ଆକାଉଣ୍ଟ ଏବଂ ସୁରକ୍ଷା",
          "content": "ପଞ୍ଜୀକୃତ କଳାକାର, ଦଳମୁଖ୍ୟ ଏବଂ ଅନୁରୋଧକାରୀ ସଂସ୍ଥାମାନେ ସେମାନଙ୍କର ଲଗ୍ଇନ୍ ପ୍ରମାଣପତ୍ରର ଗୋପନୀୟତା ରକ୍ଷା କରିବା ପାଇଁ ଦାୟୀ ରହିବେ। ପଞ୍ଜୀକରଣ ସମୟରେ ପ୍ରଦାନ କରାଯାଇଥିବା ସମସ୍ତ ସୂଚନା (ଆଧାର ଏବଂ ବ୍ୟାଙ୍କ ଆକାଉଣ୍ଟ ସମେତ) ସଠିକ୍ ଏବଂ ପ୍ରାମାଣିକ ହେବା ଆବଶ୍ୟକ ।"
        },
        {
          "title": "ଆଚରଣ ବିଧି ଏବଂ ମାର୍ଗଦର୍ଶିକା",
          "content": "ଉପଭୋକ୍ତାମାନେ ନୈତିକ ଉପାୟରେ ସାଂସ୍କୃତିକ କାର୍ଯ୍ୟକ୍ରମ ଏବଂ ସାଂସ୍କୃତିକ ଦଳ ପରିଚାଳନାରେ ଭାଗ ନେବା ଆବଶ୍ୟକ। ଏହି ପୋର୍ଟାଲ୍‌ରେ ଦାଖଲ ହୋଇଥିବା ପ୍ରଦର୍ଶନ ରିପୋର୍ଟ, ଆର୍ଥିକ ଦାବି ଏବଂ ସଦସ୍ୟଙ୍କ ପ୍ରୋଫାଇଲ୍ ସଠିକ୍ ହେବା ଆବଶ୍ୟକ । ଭୁଲ ତଥ୍ୟ ପ୍ରଦାନ କଲେ ପଞ୍ଜୀକରଣ ରଦ୍ଦ କରାଯାଇପାରେ ।"
        },
        {
          "title": "ପୋର୍ଟାଲ୍ ଉପଲବ୍ଧତା ଏବଂ ପରିବର୍ତ୍ତନ",
          "content": "ବିଭାଗ ପୂର୍ବ ସୂଚନା ବିନା ଯେକୌଣସି ସମୟରେ ସରକାରୀ ଯୋଜନା, ପ୍ରୋତ୍ସାହନ କିମ୍ବା ବୈଶିଷ୍ଟ୍ୟ ସମେତ ପୋର୍ଟାଲ୍‌ର ଯେକୌଣସି ବିଭାଗକୁ ପରିବର୍ତ୍ତନ, ସ୍ଥଗିତ କିମ୍ବା ବନ୍ଦ କରିବାର ଅଧିକାର ସରକ୍ଷିତ ରଖନ୍ତି ।"
        },
        {
          "title": "ଦାୟିତ୍ୱର ସୀମା",
          "content": "ପୋର୍ଟାଲ୍ ବ୍ୟବହାର କରିବା କିମ୍ବା ବ୍ୟବହାର କରିବାରେ ଅସମର୍ଥତା ଯୋଗୁଁ ଉପୁଜିଥିବା କୌଣସି ପ୍ରତ୍ୟକ୍ଷ, ପରୋକ୍ଷ କିମ୍ବା ଆନୁସଙ୍ଗିକ କ୍ଷତି ପାଇଁ ବିଭାଗ ଦାୟୀ ରହିବେ ନାହିଁ। ସମସ୍ତ ପ୍ରୋତ୍ସାହନ ରାଶି ପ୍ରଦାନ ତଥ୍ୟର ଯାଞ୍ଚ ଏବଂ ବଜେଟ୍ ଉପଲବ୍ଧତା ଅଧୀନରେ ରହିବ ।"
        }
      ]
    },
    "timeline": {
      "title": "ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ କାର୍ଯ୍ୟସୂଚୀ ଏବଂ ମୁଖ୍ୟ ତାରିଖ",
      "subtitle": "ଆମ କଳାକାର ପଞ୍ଜୀକରଣ, ଯାଞ୍ଚ, ଅଡ଼ିସନ୍ ଏବଂ ବୁକିଂ ପ୍ରକ୍ରିୟା ପାଇଁ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ସମୟସୀମା",
      "steps": [
        {
          "title": "ଅନୁରୋଧକାରୀ ସଂସ୍ଥା (RA) ର ଅନଲାଇନ୍ ପଞ୍ଜୀକରଣ",
          "date": "୧୬.୦୮.୨୦୨୬ ରୁ ଆଗକୁ"
        },
        {
          "title": "ସାଂସ୍କୃତିକ ଦଳ (CT) ର ଅନଲାଇନ୍ ପଞ୍ଜୀକରଣ",
          "date": "୧୬.୦୮.୨୦୨୬ ରୁ ୦୬.୦୯.୨୦୨୬ (ବର୍ଦ୍ଧିତ)"
        },
        {
          "title": "ଜିଲ୍ଲା ସାଂସ୍କୃତିକ ଅଧିକାରୀ (DCO) ସ୍ତରରେ ପ୍ରାଥମିକ ଯାଞ୍ଚ",
          "date": "୧୬.୦୮.୨୦୨୬ ରୁ ୧୦.୦୯.୨୦୨୬ (ବର୍ଦ୍ଧିତ)"
        },
        {
          "title": "ଅଡ଼ିସନ୍ ଅବଧି",
          "date": "DCO ଙ୍କ ଦ୍ୱାରା ପୋର୍ଟାଲରେ ଜଣାଇ ଦିଆଯିବ"
        },
        {
          "title": "ସାଂସ୍କୃତିକ ଦଳ (CT) ର ଚୂଡ଼ାନ୍ତ ତାଲିକା ପ୍ରକାଶନ",
          "date": "DCO ଙ୍କ ଦ୍ୱାରା ପୋର୍ଟାଲରେ ଜଣାଇ ଦିଆଯିବ"
        },
        {
          "title": "ସାଂସ୍କୃତିକ ଦଳ (CT) ଏବଂ ଅନୁରୋଧକାରୀ ସଂସ୍ଥା (RA) ର ଓରିଏଣ୍ଟେସନ୍",
          "date": "DCO ଙ୍କ ଦ୍ୱାରା ପୋର୍ଟାଲରେ ଜଣାଇ ଦିଆଯିବ"
        },
        {
          "title": "ଅନଲାଇନ୍ ସାଂସ୍କୃତିକ ଦଳ (CT) ବୁକିଂ ଆରମ୍ଭ",
          "date": "DCO ଙ୍କ ଦ୍ୱାରା ପୋର୍ଟାଲରେ ଜଣାଇ ଦିଆଯିବ"
        }
      ]
    }
  }
}

